export const IMPROVE_MATURITY_PAGE = "improve/maturity"
export const IMPROVE_GHG_PAGE = "improve/ghg"
export const IMPROVE_WEBSITES_PAGE = "improve/websites"
